import type { LoopId } from './LoopPath.no-deps'
import type { ElementId } from './types.no-deps'
import { map, uniq, flatten } from '../../lib/functional/array.no-deps'
import { pipe } from '../../lib/functional/pipe.no-deps'

/**
 * LoopPlan will be the units to loop over.
 * These will be pre-calculated as they need to be cached with the report.
 * Otherwise they may be calculated different if things change about the unit relationships
 */
export type LoopPlan = Array<{ elementId: ElementId; loopBreadthIds: LoopBreadthIds }>
export type LoopBreadthIds = LoopId[]

/**
 * Find the units to loop over. These will be pre-calculated as they need to be cached with the report
 */
export function getUnitIdsFromLoopPlan(loopPlan: LoopPlan, elementId: ElementId): LoopBreadthIds {
    return loopPlan.find((p) => p.elementId === elementId)?.loopBreadthIds ?? []
}

export function getAllUnitIdsInLoopPlan(loopPlan: LoopPlan): number[] {
    return pipe(
        loopPlan,
        map((p) => p.loopBreadthIds),
        flatten,
        map((i) => i.unitId),
        uniq
    )
}
